module.exports = __webpack_public_path__ + "static/media/a63bc877a4d4153d.cd840fd1.png";